/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkshopBrief } from './WorkshopBrief';
import {
    WorkshopBriefFromJSON,
    WorkshopBriefFromJSONTyped,
    WorkshopBriefToJSON,
    WorkshopBriefToJSONTyped,
} from './WorkshopBrief';
import type { ReviewSummary } from './ReviewSummary';
import {
    ReviewSummaryFromJSON,
    ReviewSummaryFromJSONTyped,
    ReviewSummaryToJSON,
    ReviewSummaryToJSONTyped,
} from './ReviewSummary';
import type { AdminActions } from './AdminActions';
import {
    AdminActionsFromJSON,
    AdminActionsFromJSONTyped,
    AdminActionsToJSON,
    AdminActionsToJSONTyped,
} from './AdminActions';

/**
 * Home for staff: today's and upcoming workshops, the review queue and admin actions.
 * @export
 * @interface HomeSummary
 */
export interface HomeSummary {
    /**
     * 
     * @type {Array<WorkshopBrief>}
     * @memberof HomeSummary
     */
    today?: Array<WorkshopBrief>;
    /**
     * 
     * @type {Array<WorkshopBrief>}
     * @memberof HomeSummary
     */
    upcoming?: Array<WorkshopBrief>;
    /**
     * 
     * @type {ReviewSummary}
     * @memberof HomeSummary
     */
    review: ReviewSummary;
    /**
     * 
     * @type {number}
     * @memberof HomeSummary
     */
    classes?: number;
    /**
     * 
     * @type {AdminActions}
     * @memberof HomeSummary
     */
    admin?: AdminActions | null;
}

/**
 * Check if a given object implements the HomeSummary interface.
 */
export function instanceOfHomeSummary(value: object): value is HomeSummary {
    if (!('review' in value) || value['review'] === undefined) return false;
    return true;
}

export function HomeSummaryFromJSON(json: any): HomeSummary {
    return HomeSummaryFromJSONTyped(json, false);
}

export function HomeSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'today': json['today'] == null ? undefined : ((json['today'] as Array<any>).map(WorkshopBriefFromJSON)),
        'upcoming': json['upcoming'] == null ? undefined : ((json['upcoming'] as Array<any>).map(WorkshopBriefFromJSON)),
        'review': ReviewSummaryFromJSON(json['review']),
        'classes': json['classes'] == null ? undefined : json['classes'],
        'admin': json['admin'] == null ? undefined : AdminActionsFromJSON(json['admin']),
    };
}

export function HomeSummaryToJSON(json: any): HomeSummary {
    return HomeSummaryToJSONTyped(json, false);
}

export function HomeSummaryToJSONTyped(value?: HomeSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'today': value['today'] == null ? undefined : ((value['today'] as Array<any>).map(WorkshopBriefToJSON)),
        'upcoming': value['upcoming'] == null ? undefined : ((value['upcoming'] as Array<any>).map(WorkshopBriefToJSON)),
        'review': ReviewSummaryToJSON(value['review']),
        'classes': value['classes'],
        'admin': AdminActionsToJSON(value['admin']),
    };
}

